import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { Subscription } from "rxjs";
import { EnergyCoefficient } from "src/model/enum/enumDigitalPlace";
import { LogLevel } from "src/components/shared-components/enum/enumLog";
import { iEvent } from "src/components/shared-components/interfaces/iEvent";
import { EventService } from "src/service/event.service";
import { LoggerService } from "src/service/logger.service";

@Component({
    selector: "app-popup-energy-coefficient",
    templateUrl: "./popup-energy-coefficient.component.html",
    styleUrls: ["./popup-energy-coefficient.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopupEnergyCoefficientComponent
  implements OnInit, OnDestroy, iEvent {
  private _logContext: "Popup-energy-coefficient.component";
  public _eventSubscriptions: Array<Subscription> = null;
  public energyCoefficientOptions = Object.keys(EnergyCoefficient)
    .filter((key) => /[A-G]\+*\**/.test(key))
    .map((key) => {
      return {
        label: key,
        value: parseInt(EnergyCoefficient[key], 10),
      };
    });

  @Input() modalRef: ModalController;
  @Input() chipSelected: number;

  constructor(
    private _modalController: ModalController,
    private _loggerService: LoggerService,
    private _eventService: EventService
  ) { }

  ngOnInit() {
    this.subscribeEvents();
  }

  ngOnDestroy(): void {
    this.unsubscribeEvents();
  }

  /**
   * Close modal and return index selected
   * @param valSelected
   */
  public closeModal(indexSelected?: number) {
    this.modalRef.dismiss({
      data: indexSelected,
    });
  }

  /**
   * Get class of badge of chip
   * @param value
   * @returns
   */
  public getClassChip(value) {
    let classChip: string = "leftChip ";
    if (
      value != EnergyCoefficient["A4"] &&
      value != EnergyCoefficient["A3"] &&
      value != EnergyCoefficient["A2"] &&
      value != EnergyCoefficient["A1"]
    ) {
      classChip += " ion-chip-" + EnergyCoefficient[value].toLowerCase();
    } else {
      if (value == EnergyCoefficient["A4"]) {
        classChip += " ion-chip-appp";
      } else if (value == EnergyCoefficient["A3"]) {
        classChip += " ion-chip-app";
      } else if (value == EnergyCoefficient["A2"]) {
        classChip += " ion-chip-ap";
      } else if (value == EnergyCoefficient["A1"]) {
        classChip += " ion-chip-a";
      }
    }
    if (value == this.chipSelected) {
      classChip += "-selected noPointer ";
    }
    return classChip;
  }

  /**
   * Get width of badge
   * @param value
   * @returns
   */
  public getWidthChip(value) {
    let val = 65 + 100 - value;
    if (value != 100) {
      val += 5 * ((100 - value) / 10);
    }
    return val + "px";
  }

  //#region Subscribe to event-service observable
  subscribeEvents(): void {
    this._eventSubscriptions = new Array<Subscription>();

    this._eventSubscriptions.push(
      this._eventService.OnMakeForceLogout.subscribe(() => {
        this._modalController.dismiss();
      })
    );
  }

  unsubscribeEvents(): void {
    for (let sub of this._eventSubscriptions) {
      sub.unsubscribe();
    }
  }
  //#endregion
}
